class MyDeliverySaverService {
    constructor($q, deliverySaverService) {
        this.$q = $q;
        this.deliverySaverService = deliverySaverService;
    }

    initalize() {
        this.subscription = null;
        this.eligibility = null;
        this.payments = [];
        this.lastPayment = null;
        this.discounts = [];
        this.totalDiscount = 0;
        this.loading = true;

        return this.$q.all([
            this.loadPayments(),
            this.loadSubscription(),
            this.loadDiscounts(),
            this.loadEligibility(),
        ]);
    }

    loadPayments() {
        return this.deliverySaverService.getPayments().then((data) => {
            this.payments = data.Payments;
            this.lastPayment = this.payments && this.payments.sort((a, b) => {
                if (a.PaymentDate > b.PaymentDate) return -1;
                if (a.PaymentDate < b.PaymentDate) return 1;
                return 0;
            })[0];
        });
    }

    loadDiscounts() {
        return this.deliverySaverService.getDiscounts().then((data) => {
            this.discounts = data.Discounts;
            this.totalDiscount = this.discounts.reduce((a, c) => a + c.TotalDiscount, 0);
        });
    }

    loadSubscription() {
        return this.deliverySaverService.getSubscription().then((data) => {
            if (data.Subscription.Status !== 'Cancelled') {
                this.subscription = data.Subscription;
                this.plan = data.Plan;
            }
        });
    }

    loadEligibility() {
        return this.deliverySaverService.getEligibility().then((data) => {
            this.eligibility = data;
        });
    }

    retryPayment() {
        return this.deliverySaverService.retryPayment()
            .then((updateResponse) => {
                this.subscription = updateResponse.Subscription;
                return this.loadPayments();
            });
    }

    cancelSubscription() {
        return this.deliverySaverService.cancelSubscription().then((cancelResponse) => {
            this.subscription = cancelResponse.Subscription;
        });
    }
}

MyDeliverySaverService.$inject = ['$q', 'DeliverySaverService'];

module.exports = { MyDeliverySaverService };



// WEBPACK FOOTER //
// ./src/deliverysaver/mydeliverysaver/my-delivery-saver.service.js